---
title: "Experiences of Large Banks: Hurdles and enablers to the adoption of Software Product Line Practices in large corporate organisations"
slug: experiences-of-large-banks
type: paper
status: published
featured: true
summary: Hurdles observed while adopting software product-line practices in large financial-services organisations, including the ROI problem across business-unit boundaries.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2008-09-08"
lastReviewedAt: "2026-09-18"
audiences:
  - business
  - product-developer
themes:
  - product-lines
  - platform-architecture
sourceUrl: https://ucla.academia.edu/JayvanZyl
originalAuthor: Jay van Zyl
sourceRelationship: academic / IEEE conference record
rightsStatus: outbound-only
seoDescription: 2008 IEEE paper by Jay van Zyl on software product-line adoption in large banks.
canonicalPath: /research/experiences-of-large-banks
authors:
  - Jay van Zyl
year: 2008
venue: IEEE Computer Society
publicationType: conference
citation: "van Zyl, J. (2008, September 8). Experiences of Large Banks: Hurdles and enablers to the adoption of Software Product Line Practices in large corporate organisations. IEEE Computer Society."
researchTheme: product-line-architecture
recordUrl: https://ucla.academia.edu/JayvanZyl
---

One documented hurdle: business divisions struggle to see return when a product line crosses unit boundaries. That is still the platform-strategy conversation I have with leadership teams.
